import { datadogLogs, HandlerType } from '@datadog/browser-logs';
import { config } from '@tools/ui/consts';

datadogLogs.init({
  clientToken: config.dataDog.clientToken as string,
  site: config.dataDog.site,
  service: config.dataDog.service,
  env: config.appEnv,
  forwardErrorsToLogs: true,
  sampleRate: 100,
  useCrossSiteSessionCookie: true
});

if (config.appEnv !== 'production') {
  datadogLogs.logger.setHandler(HandlerType.console);
}

export const logger = {
  setUser(userInfo) {
    datadogLogs.setUser(userInfo);
  },
  debug(message: string, optionalParams: Record<string, unknown>): void {
    datadogLogs.logger.debug(message, { payload: optionalParams });
  },
  log(message: string, optionalParams: Record<string, unknown>): void {
    datadogLogs.logger.log(message, { payload: optionalParams });
  },
  info(message: string, optionalParams: Record<string, unknown>): void {
    datadogLogs.logger.info(message, { payload: optionalParams });
  },
  warn(message: string, optionalParams: Record<string, unknown>): void {
    datadogLogs.logger.warn(message, { payload: optionalParams });
  },
  error(message: string, optionalParams: Record<string, unknown>): void {
    datadogLogs.logger.error(message, { payload: optionalParams });
  }
};
